var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconQuote = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 68,
  height: 45,
  viewBox: "0 0 68 45",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M30 30l-7.5 7.5L15 45V30H0V0h30v30zm38 0l-7.5 7.5L53 45V30H38V0h30v30z",
  fill: "#001246",
  fillRule: "evenodd"
})));
export default SvgIconQuote;